<template>
	<Skeleton :paragraph="{ rows: 7 }" :title="false" :loading="isLoading">
		<VerticalLayout>
			<div class="scrollable-x">
				<Table
					:columns="columns"
					:data-source="items"
					:pagination="false"
					size="small"
					row-key="webui_version"
				>
					<template #bodyCell="{ column, record }">
						<template v-if="column.dataIndex === 'run_at'">
							<DateTimeDisplay :date="record.run_at" hideUtc />
						</template>
					</template>
				</Table>
			</div>
		</VerticalLayout>
	</Skeleton>
</template>

<script>
import { ref, onMounted } from 'vue';
import { Skeleton, Table } from 'ant-design-vue';

import Api from '@/api/Api';
import Consts from '@/api/Consts';

import DateTimeDisplay from '@/components/common/DateTimeDisplay';
import VerticalLayout from '@/components/common/VerticalLayout';

export default {
	components: {
		Skeleton, Table, DateTimeDisplay, VerticalLayout,
	},
	setup() {
		const isLoading = ref(false);
		const items = ref([]);
		const columns = Consts.versionHistoryTableColumnsComp;

		const fetchData = () => {
			isLoading.value = true;
			Api.versionHistoryGet(response => {
				if (response.status === 'ok') {
					items.value = response.items || [];
				}
				isLoading.value = false;
			});
		};

		onMounted(fetchData);

		return {
			isLoading,
			items,
			columns,
		};
	},
}
</script>
